<template>
  <f7-app
    :params="f7params">
    <f7-statusbar />

    <f7-view main>
      <Home />
    </f7-view>
    <!-- <f7-view
      v-if="allReady"
      :url="url"
      :main="true" /> -->

      <pre>{{ deviceReady }}</pre>
      <pre>{{ f7ready }}</pre>
      <pre>{{ allReady }}</pre>

  </f7-app>
</template>

<script>
import { mapGetters } from 'vuex'
// import localize from './mixins/localize'
import routes from './routes'
import Home from './components/routes/home'

let theme = 'auto'
if (document.location.search.indexOf('theme=') >= 0) {
  theme = document.location.search.split('theme=')[1].split('&')[0]
}

export default {
  name: 'app',
  components: {
    Home
  },
  // sockets: {
  //   connect () {
  //     console.log('socket connected')
  //   }
  // },
  data () {
    return {
      deviceReady: false,
      f7ready: false,
      f7params: {
        theme,
        // theme: 'ios',
        routes,
        id: 'io.atlastories.app'
      }
    }
  },
  // mixins: [
  //   localize
  // ],
  computed: {
    ...mapGetters({
      userName: 'user/name'
    }),
    allReady () {
      // eslint-disable-next-line
      return this.deviceReady && this.f7ready ? true : false
    },
    url () {
      return this.userName ? '/' : '/signin'
    }
  },
  // watch: {
  //   allReady (ready) {
  //     if (ready) this.initLocation()
  //   }
  // },
  created () {
    document.addEventListener('deviceready', () => {
      this.deviceReady = true
      // if (device.platform === 'browser') {
      //   console.log('ask for navigator location')
      // } else {
      //   // from mixin localize
      //   this.initLocation()
      // }
    }, false)
  },
  mounted () {
    this.$f7ready(f7 => {
      this.f7ready = true
    })
  }
}
</script>

<style lang="scss">
@import './assets/styles/app';
</style>
